import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { TransactionStatus } from './transaction-status.const';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'history-transaction-status',
  templateUrl: './transaction-status.component.html',
  styleUrls: ['./transaction-status.component.css'],
  standalone: true,
  imports: [CommonModule, SharedModule],
})
export class HistoryTransactionStatusComponent {
  @Input() status = '';

  protected readonly TransactionStatus = TransactionStatus;

  constructor(public translate: TranslateService) {}

  getTransactionStatusTranslation(status: string): string {
    const key = `transaction-history.status.${status}`;
    const translation = this.translate.instant(key);
    return key === translation ? status : translation;
  }
}
